// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".single-city .thumb {\n    height: 220px;\n    overflow: hidden;\n  }\n  \n  .single-city .thumb img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n  ", ""]);
// Exports
module.exports = exports;
